import App from './App.jsx';
import LandingPage from './LandingPage.jsx';
import { useEffect } from 'react';
import AuthGate from './AuthGate.jsx';
import PrivacyPolicy from './components/legal/PrivacyPolicy.jsx';
import TermsOfService from './components/legal/TermsOfService.jsx';
import SpecifiedCommercialTransactions from './components/legal/SpecifiedCommercialTransactions.jsx';
import { initAnalytics, trackPageView } from './lib/analytics.js';

export default function Root() {
  const path = window.location.pathname;

  useEffect(() => {
    // GA4 を全ページで初期化（Opt-out は analytics.js 側で制御）
    initAnalytics();
  }, []);

  useEffect(() => {
    // Route 単位の PageView 計測
    let surface = 'lp';
    let pageTitle = 'Landing Page';

    if (path.startsWith('/demo')) {
      surface = 'demo';
      pageTitle = 'Demo Mode';
    } else if (path === '/' || path.startsWith('/app')) {
      surface = 'app';
      pageTitle = 'App';
    } else if (path === '/about') {
      surface = 'lp';
      pageTitle = 'Landing Page';
    } else if (path === '/privacy') {
      pageTitle = 'Privacy Policy';
    } else if (path === '/terms') {
      pageTitle = 'Terms of Service';
    } else if (path === '/tokushoho') {
      pageTitle = 'Specified Commercial Transactions';
    }

    trackPageView(pageTitle, surface);
  }, [path]);

  if (path === '/privacy') return <PrivacyPolicy />;
  if (path === '/terms') return <TermsOfService />;
  if (path === '/tokushoho') return <SpecifiedCommercialTransactions />;
  if (path === '/about') return <LandingPage />;

  // デモモード：Cloudflare等でも公開される (public mock mode)
  if (path.startsWith('/demo')) return <App surface="demo" />;

  // 本番用アプリ：AuthGate で認証とアクセス制御を行う。/app は既存リンク互換として残す。
  if (path === '/' || path.startsWith('/app')) {
    return (
      <AuthGate surface="app">
        <App surface="app" />
      </AuthGate>
    );
  }

  // それ以外はアプリ本体にフォールバック
  return (
    <AuthGate surface="app">
      <App surface="app" />
    </AuthGate>
  );
}
